import { gql } from "@apollo/client";

export const GET_ABANDON_REASONS = gql`
  query AbandonReasons($searchKey: String!, $hubSearchId: String!) {
    abandonReasons(searchKey: $searchKey, hubSearchId: $hubSearchId) {
      messageDescription
      responseData {
        created_by
        created_on
        id
        is_active
        reason_name
        updated_by
        updated_on
      }
      successTypeCode
    }
  }
`;
// {
//   "bid": "GRN-DEV-202506-15197",
//   "mail_to": "projects@grnconnect.com",
//   "mail_from": "saikrishna.kadari@techwave.com",
//   "mail_bcc": null,
//   "mail_cc": null
// }
export const SEND_VOUCHER_MAIL = gql`
  mutation ($request: VoucherSendMailVMInput!) {
    sendVoucherMail(voucherSendMailVM: $request) {
      responseData {
        bid
        mail_bcc
        mail_cc
        mail_content
        mail_from
        mail_to
        voucher_content
      }
      successTypeCode
      messageDescription
    }
  }
`;

export const VALIDATE_DUPLICATE_BOOKING_QUERY = gql`
  query ValidateDuplicateBooking(
    $duplicateBookingValidation: DuplicateBookingValidationVMInput!
  ) {
    validateDuplicateBooking(
      duplicateBookingValidation: $duplicateBookingValidation
    ) {
      messageDescription
      responseData {
        is_restrict
        message
        confirm_proceed
        previous_bid
        is_online_payment
      }
      successTypeCode
    }
  }
`;

export const BOOKABLE_THRESHOLD_LIMIT_DETAILS_QUERY = gql`
  query BookableThresholdLimit($request: String) {
    bookableThresholdLimit(request: $request) {
      correlationId
      messageCode
      messageDescription
      orderByData
      responseData
      successTypeCode
      totalRecords
    }
  }
`;

export const BOOKABLE_CL_DETAILS_QUERY = gql`
  query BookableCl($agent_id: Long!) {
    bookableCl(agent_id: $agent_id) {
      correlationId
      messageCode
      messageDescription
      orderByData
      responseData
      successTypeCode
      totalRecords
    }
  }
`;

export const BOOKABLE_WB_DETAILS_QUERY = gql`
  query BookableWB($agent_id: Long, $walletType: String) {
    bookableWB(agent_id: $agent_id, walletType: $walletType) {
      correlationId
      messageCode
      messageDescription
      orderByData
      responseData
      successTypeCode
      totalRecords
    }
  }
`;

export const AGENT_PROFILE_BY_ID_QUERY = gql`
  query ($agentId: UUID!) {
    agentProfileByAgentId(id: $agentId) {
      responseData {
        agency_email
        agent_id
        agent_name
        agent_number
        allocated_credit_limit
        allocated_threshold_limit
        api_key
        approval_status
        available_credit_limit
        available_threshold_limit
        bookable_credit_limit
        bookable_threshold_limit
        contact_person
        country_code
        email
        employee_name
        empolyee_agent_id
        hierarchy
        invoice_currency
        invoicing_entity
        is_cl_enabled
        is_temp_cl_enabled
        l1_agent_number
        max_credit_limit
        max_threshold_limit
        online_payment_enabled
        online_payment_surchage
        online_payment_surcharge_inclusive
        ops_spoc
        ops_spoc_email
        ops_spoc_phone
        parent_id
        preferred_currency
        sales_spoc
        sales_spoc_email
        sales_spoc_phone
        user_id
        wallet_balance
        wallet_balance_from_parent
      }
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const GET_PAYMENT_GATEWAY_TRANSACTIONS_QUERY = gql`
  query paymentGatewayTransactions(
    $searchValues: PaymentGatewayTransactionFilterVMInput!
  ) {
    paymentGatewayTransactions(searchValues: $searchValues) {
      successTypeCode
      totalRecords
      responseData {
        agent_id
        agent_uuid
        bid
        billing_location
        convinience_fee
        convinience_fee_percent
        country
        created_by
        created_by_role
        created_on
        final_amount
        id
        ip_address
        l1_agent_id
        l1_agent_uuid
        order_amount
        order_currency
        order_date
        order_id
        pay_gateway
        pay_reason
        payment_confirmation_date
        payment_status
        payment_type
        payment_type_ui
        pg_charge_amount
        pg_charge_currency
        process_type
        secure_id
        temp_bid
        transaction_id
        type_of_card
        updated_by
        updated_by_role
        updated_on
        user_id
        validation_status
      }
    }
  }
`;

export const VALIDATE_PAYMENT_LINK_MUTATION = gql`
  mutation ValidatePaymentLink($data: String!) {
    validatePaymentLink(data: $data) {
    messageCode
    messageDescription
    responseData
    successTypeCode
    }
  }
`;

export const POST_PAYMENT_GATEWAY_MUTATION = gql`
  mutation PostPaymentGateway($input: PaymentGatewayQueryParametersInput!) {
    postPaymentGateway(input: $input) {
      messageCode
      responseData
      successTypeCode
    }
  }
`;

export const VALIDATE_PG_CURRENCY_QUERY = gql`
  query validatePGCurrency($input: ValidatePGCurrencyParametersInput!) {
    validatePGCurrency(input: $input) {
      correlationId
      failedTypeCode
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData 
    }
  }
`;

export const VOUCHER_VIEW_DETAILS_QUERY = gql`
  query VoucherViewDetails($bid: String!) {
    voucherViewDetails(bid: $bid) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        voucher_content
        voucher_html
        bookings_info {
          agency_email
        }
      }
    }
  }
`;

export const VOUCHER_VIEW_EURAIL_DETAILS_QUERY = gql`
  query eurailVoucherViewDetails($bid: String!) {
    eurailVoucherViewDetails(bid: $bid) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        voucher_content
        voucher_html
        agency_email
      }
    }
  }
`;

export const VOUCHER_VIEW_TRANSFER_DETAILS_QUERY = gql`
  query VoucherViewTransferDetails($bid: String!) {
    voucherViewTransferDetails(bid: $bid) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        voucher_content
        voucher_html
        transfer_info {
          agency_email
        }
      }
    }
  }
`;

export const VOUCHER_VIEW_ACTIVITY_DETAILS_QUERY = gql`
  query VoucherViewActivityDetails($bid: String!) {
    voucherViewActivityDetails(bid: $bid) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        voucher_content
        voucher_html
        bookings_info {
          agency_email
        }
      }
    }
  }
`;

export const BID_FROM_TEMP_ID_QUERY = gql`
  query BiDfromTempId($temp_id: String!) {
    biDfromTempId(temp_id: $temp_id) {
      responseData
      successTypeCode
      messageDescription
    }
  }
`;

export const UPDATE_PG_INVOICE_NUMBER_QUERY = gql`
  mutation UpdatePGInvoiceNumber(
    $updatePGInvoiceNumber: UpdatePGInvoiceNumberVMInput!
  ) {
    updatePGInvoiceNumber(updatePGInvoiceNumber: $updatePGInvoiceNumber) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        bid
        temp_bid
      }
    }
  }
`;

export const PASSPORT_DETAILS_BY_BOOKINGID_QUERY = gql`
  query PassportDetailsByBookingId($booking_reference_id: String!) {
    passportDetailsByBookingId(booking_reference_id: $booking_reference_id) {
      responseData {
        booking_reference_id
        document_name
        document_path
        document_seqno
        product_info
      }
      messageDescription
    }
  }
`;

export const ADD_BOOKING_MAIL_DATA_MUTATION = gql`
  mutation AddBookingMailData($bookingMailDataVM: BookingMailDataVMInput!) {
    addBookingMailData(bookingMailDataVM: $bookingMailDataVM) {
      responseData {
        bid
        booking_status
        created_by
        created_on
        id
        mail_sent_status
        type_of_booking
      }
      successTypeCode
    }
  }
`;

export const CHECK_PAN_EXISTS_FOR_AGENT_DATA_QUERY = gql`
  query CheckPanExistForagent($pan: String!, $agent_id: UUID!) {
    checkPanExistForagent(pan: $pan, agent_id: $agent_id) {
      responseData
      successTypeCode
      messageDescription
    }
  }
`;

export const GRN_INVOICES_LIST = gql`
  query ($request: InvoiceFilterGRNListVMInput!) {
    grnInvoice(filter: $request) {
      responseData {
        count {
          total_count
        }
        invoices {
          agent_address1
          agent_address2
          agent_city
          agent_commission_amount_l0
          agent_commission_amount_l1
          agent_commission_percentage_l0
          agent_commission_percentage_l1
          agent_country
          agent_gst_number
          agent_markup_amount
          agent_markup_percentage
          agent_name
          agent_ops_person
          agent_postal_code
          agent_reference
          agent_sales_person
          agent_state
          bid
          booking_date
          booking_id
          booking_reference
          booking_status
          cancel_by_date
          cancellation_date
          cgst
          channel
          convinience_fee
          created_by
          created_on
          credit_card_charges_amount
          credit_card_charges_percentage
          due_date
          gst_state_code
          irn_qr_code
          irn_error
          id
          igst
          invoice_amount
          invoice_currency
          invoice_date
          invoice_document
          invoice_number
          invoice_roe
          irn_number
          lead_pax_name
          non_refundable
          number_of_nights
          number_of_rooms
          pax_number
          pax_list
          pan_list
          pan_number
          place_of_supply
          roundoff
          sale_amount_net
          sale_payable_amount
          sale_roe
          sales_ledger
          sales_type
          service
          service_city
          service_country
          service_date_end
          service_date_start
          service_fee
          service_name
          service_type
          sgst
          started_by
          submission_date
          supplier_markup_amount
          supplier_markup_percentage
          tech_platform_commission_amount_agent
          tech_platform_percentage_agent
          trade_discount
          updated_by
          updated_on
          vat
          vendor
          vendor_confirmation_number
        }
      }
      successTypeCode
      messageDescription
    }
  }
`;

export const GRN_PROFORMAS_LIST = gql`
  query proformaInvoiceDetails($bid: String!) {
    proformaInvoiceDetails(bid: $bid) {
      correlationId
      messageCode
      messageDescription
      successTypeCode
      totalRecords
      responseData {
        agency_email
        agency_name
        agent_address1
        agent_address2
        agent_city
        agent_commission_amount_l0
        agent_commission_amount_l1
        agent_commission_percentage_l0
        agent_commission_percentage_l1
        agent_country
        agent_gst_number
        agent_markup_amount
        agent_markup_percentage
        agent_name
        agent_ops_person
        agent_postal_code
        agent_reference
        agent_sales_person
        agent_state
        bid
        booking_date
        booking_id
        booking_name
        booking_reference
        booking_status
        cancel_by_date
        cancellation_date
        cgst
        channel
        convinience_fee
        country
        created_by
        created_on
        credit_card_charges_amount
        credit_card_charges_percentage
        due_date
        email
        from_date
        gst_number
        gst_state_code
        hotel_address
        hotel_country_name
        hotel_name
        igst
        invoice_amount
        invoice_currency
        invoice_date
        invoice_document
        invoice_number
        invoice_roe
        irn_number
        lead_pax_name
        mobile
        non_refundable
        number_of_nights
        number_of_rooms
        office_code
        pax_number
        place_of_supply
        roundoff
        sale_amount_net
        sale_payable_amount
        sale_roe
        sales_ledger
        sales_type
        service
        service_city
        service_country
        service_date_end
        service_date_start
        service_fee
        service_name
        service_type
        sgst
        started_by
        submission_date
        supplier_markup_amount
        supplier_markup_percentage
        tech_platform_commission_amount_agent
        tech_platform_percentage_agent
        telephone
        to_date
        total_price
        trade_discount
        updated_by
        updated_on
        vat
        vendor
        vendor_confirmation_number
      }
    }
  }
`;

export const GET_ITINERARY_ID_BY_TEMPID_QUERY = gql`
  query ItineraryIdByTempId($temp_id: String!) {
    itineraryIdByTempId(temp_id: $temp_id) {
      messageDescription
      responseData {
        itinerary_id
        returns_bid
        onwards_bid
      }
      successTypeCode
    }
  }
`;

export const AGENT_INFO_FINALIZE_TRANSFER_QUERY = gql`
  query ($searchValues: FinalizeTransferAgentReqPayloadVMInput!) {
    agentInfoForFinalizeTransfer(searchValues: $searchValues) {
      messageCode
      successTypeCode
      messageDescription
      responseData {
        agent_currency
        agent_id
        agent_markup
        agent_payment_mode
        api_key
        booking_amount
        credit_balance
        currency
        deduct_amount
        global_agent_markup
        grn_agent_id
        invoicing_entity_id
        is_premium_agent
        parent_wallet_balance
        total_booking_amount
        total_deduct_amount
        wallet_balance
      }
    }
  }
`;

export const PRICE_CALCULATE_OC_PC_QUERY = gql`
  mutation priceCalculateOcPc($input: String!) {
    priceCalculateOcPc(input: $input) {
      responseData
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const POST_PRICE_CALCULATE_MUTATION = gql`
  mutation postPriceCalculate($input: String!) {
    postPriceCalculate(input: $input) {
      responseData
      messageDescription
      successTypeCode
    }
  }
`;

export const GET_AGENTS_BY_CURRENCY_QUERY = gql`
  query ($currency: String!) {
    agentsByCurrency(currency: $currency) {
      responseData {
        agentsByCurrencyList {
          agency_email
          agency_name
          agent_id
          id
          api_key
        }
      }
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const AGENTS_BY_CURRENCY_AND_INVOICEENTITY_QUERY = gql`
  query ($currency: String!, $invoicing_entity_id: UUID!) {
    agentsByCurrencyAndInvoiceEntity(
      currency: $currency
      invoicing_entity_id: $invoicing_entity_id
    ) {
      responseData {
        agentsByCurrencyList {
          agency_email
          agency_name
          agent_id
          id
          api_key
        }
      }
      successTypeCode
      messageDescription
      messageCode
    }
  }
`;

export const GET_BOOKINGS_LIST_BY_GRN = gql`
  query ($searchValues: GRNUserBookingsFilterVMInput!) {
    grnUserBookingsList(searchValues: $searchValues) {
      responseData {
        adminBookingsCount {
          active_count
          allTrays_count
          cancelled_count
          failed_count
          finalized_count
          flagged_count
          onRequest_count
          rejected_count
          timeLimit_count
          clarification_count
        }
        adminBookingsLists {
          agency_email
          agency_name
          agent_id
          agent_level
          agent_reference
          auto_mapping
          agent_uuid
          bid
          booking_date
          booking_draft_id
          booking_name
          booking_reference
          booking_reference_id
          booking_timeout_exceeded
          cancel_by_date
          cancel_date
          cancellation_date
          channel
          checkin_date
          checkout_date
          city_name
          country_name
          created_by_name
          currency
          employee_id
          employee_name
          featured_hotel
          finalize
          grn_agent_id
          hcn
          hold_by
          hold_by_name
          holder
          holder_middle_name
          host_name
          hotel_code
          hotel_name
          hubSearchId
          inventory_type
          invoice_number
          is_amendment
          is_booking_transferred
          is_clarification_request_raised
          is_credit_note
          is_featured_hotel
          is_finalized
          is_invoiced
          is_premium_agent
          is_transfer_onwards
          is_transfer_return
          is_transferred_booking
          is_two_way_transfer
          itinerary_id
          lead_source
          nbr
          no_of_nights
          no_of_rooms
          non_refundable
          office_code
          online_payment_status
          pan_exists
          pan_required
          passport_exist
          passport_required
          pax
          payment_method
          payment_reference_number
          price
          product_type
          purchase_price
          purpose_of_travel
          remarks
          response_time
          search_id
          source_market
          status
          supplier_code
          supplier_group_name
          supplier_price
          supplier_reference
          transfer_total_price
          under_cancellation
          api_key
          eurail_type
          service_name
          agent_cancellation_amount
          agent_cancellation_currency
          supplier_cancellation_amount
          supplier_cancellation_currency
        }
      }
      messageDescription
      successTypeCode
      messageCode
    }
  }
`;

export const ADD_TRANSFER_TO_AGENT_MUTATION = gql`
  mutation AddTransferToAgent(
    $transferToAgentBooking: AddTransferToAgentBookingVMInput!
  ) {
    addTransferToAgent(transferToAgentBooking: $transferToAgentBooking) {
      responseData {
        adhoc_markup_percentage
        agent_id
        bid
        booking_amount
        booking_type
        bref
        created_by
        created_on
        currency
        grn_agent_id
        grn_updated_markups
        is_finalize_transfer
        payment_deduction_from
        transfer_to
        tw_booking_id
      }
    }
  }
`;

export const ADD_FINALIZE_BOOKINGS_QUERY = gql`
  mutation ($request: AddFinalizedBookingsVMInput!) {
    addFinalizedBookings(addFinalizedBookingsVM: $request) {
      responseData {
        id
        messages
        statusCode
      }
      messageDescription
      successTypeCode
    }
  }
`;

export const ADD_FINALIZED_BOOKINGS_TRANSFER_AGENT = gql`
  mutation ($request: AddFinalizedBookingsForTransferVMInput!) {
    addFinalizedBookingsForTransferProduct(
      addFinalizedBookingsForTransferVM: $request
    ) {
      responseData {
        id
        messages
        statusCode
      }
      messageDescription
      successTypeCode
    }
  }
`;

export const ADD_FINALIZE_BOOKINGS_TRANSFER_ADMIN = gql`
  mutation ($request: AddFinalizedBookingsForTransferVMInput!) {
    addFinalizeAndTransferForTransferProduct(
      addFinalizedBookingsForTransferVM: $request
    ) {
      responseData {
        id
        messages
        statusCode
      }
      messageDescription
      successTypeCode
    }
  }
`;

export const ADD_TRANSFER_TO_AGENT_TRASFER_MUTATION = gql`
  mutation AddTransferToAgentForTransferProduct(
    $transferToAgentBooking: AddTransferToAgentForTransferProductVMInput!
  ) {
    addTransferToAgentForTransferProduct(
      transferToAgentBooking: $transferToAgentBooking
    ) {
      responseData {
        adhoc_markup_percentage
        agent_id
        bid
        booking_amount
        booking_type
        bref
        created_by
        created_on
        currency
        grn_agent_id
        grn_updated_markups
        is_finalize_transfer
        payment_deduction_from
        transfer_to
        tw_booking_id
      }
    }
  }
`;

export const ACCESS_NOTIFICATIONS_QUERY = gql`
  query ($agent_id: Long!) {
    bdAcessandNotifications(agent_id: $agent_id) {
      messageCode
      messageDescription
      successTypeCode
      responseData {
        print_voucher
        view_voucher
      }
    }
  }
`;
export const REQUEST_FAILURE_REASON_STATUS_MUTATION = gql`
  mutation ($request: updatebookingdraftStatusVMInput!) {
    updatebookingdraftStatus(request: $request) {
      responseData
      messageDescription
      messageCode
      successTypeCode
    }
  }
`;
